import { useProceduralError } from "../../Hooks/Features/Inspectra/useProceduralError";
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import HighchartsMore from "highcharts/highcharts-more";
import { Dialog } from 'primereact/dialog';
import DatePicker from "react-multi-date-picker";
import { SkeletonContainer } from '../Loader/Loader.jsx';
import { MultiSelect } from "primereact/multiselect";
import PanelHeaderTemplate from "../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { dateConvert, timePickerMuiCss } from "../../utils/Helper.js";
import { Calendar } from "primereact/calendar";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
HighchartsMore(Highcharts);

const ProceduralError = ({ projectChanged }) => {

    const { options, showPopup, setShowPopup, popupData, hoveredRange, loader, showFilter, setShowFilter, filterOpts, filterValues, setFilterValues, filterCount, expand, setExpand, time, setTime, handleDateRange, handleApplyFilters, handleDefaultFilters } = useProceduralError({ projectChanged });

    return (
        <div className="inspectra-widget-container p-2">
            <div className="d-flex justify-content-between align-items-center">
                <div className="inspectra-widget-header">Procedural Errors</div>
                <div className="text-primary inspectra-cursor inspectra-filter d-flex gap-1 align-items-center" onClick={() => setShowFilter(true)}><span className="inspectra-filter-count">{filterCount}</span>filters</div>
            </div>
            <div className="inspectra-date-string">{dateConvert(filterValues?.date?.from_date, "date-time-months")} - {dateConvert(filterValues?.date?.to_date, "date-time-months")}</div>
            <div className="inspectra-widget-content">
                {loader ? <SkeletonContainer /> :
                    <HighchartsReact className="highcharts-container" highcharts={Highcharts} options={options} containerProps={{
                        style: {
                            height: "99%"
                        }
                    }} />
                }
            </div>

            <div className="position-absolute bottom-0 end-0 me-1 fs-6 c-pointer" onClick={() => setExpand(true)}>
                <FontAwesomeIcon icon="fa-solid fa-expand" />
            </div>

            <Dialog visible={showFilter} onHide={() => setShowFilter(false)} className="modal-small" draggable={false} header="Procedural Errors Filters">
                <div>
                    <div className="d-flex gap-2 inspectra-calendar">
                        <div className="w50">
                            <div>Date: </div>
                            <div>
                                <DatePicker portal zIndex={99999} value={hoveredRange} onChange={handleDateRange} range rangeHover placeholder="Select Date Range" style={{ width: "100%" }} />
                            </div>
                        </div>
                        <div className="w45 d-flex gap-2 justify-content-between">
                            <div className="w50">
                                <div>From Time: </div>
                                <TimePicker value={time?.from || null} onChange={(e) => setTime((prev) => ({ ...prev, from: e }))} sx={{ ...timePickerMuiCss, backgroundColor: "white", margin: "2px 2px" }}
                                    slotProps={{
                                        textField: {
                                            label: undefined,
                                        }
                                    }}
                                />
                            </div>
                            <div className="w50">
                                <div>To Time: </div>
                                <TimePicker value={time?.to || null} onChange={(e) => setTime((prev) => ({ ...prev, to: e }))} sx={{ ...timePickerMuiCss, backgroundColor: "white", margin: "2px 2px" }}
                                    slotProps={{
                                        textField: {
                                            label: undefined,
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="d-flex gap-2">
                        <div className="w50">
                            <div>Database:</div>
                            <MultiSelect options={filterOpts?.dbname} placeholder="Database" value={filterValues?.dbname} onChange={(e) => setFilterValues((prev) => ({ ...prev, dbname: e.target.value }))} panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'dbname', filterValues?.dbname, () => setFilterValues((prev) => ({ ...prev, dbname: [] })))} filter filterInputAutoFocus />
                        </div>
                        <div className="w50">
                            <div>Procedure:</div>
                            <MultiSelect options={filterOpts?.procedure} placeholder="Procedure" value={filterValues?.procedure} onChange={(e) => setFilterValues((prev) => ({ ...prev, procedure: e.target.value }))} panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'procedure', filterValues?.procedure, () => setFilterValues((prev) => ({ ...prev, procedure: [] })))} filter filterInputAutoFocus />
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-2">
                        <div className="text-primary c-pointer" onClick={() => handleDefaultFilters()}>Select default filters</div>
                        <button className="button btn-primary" onClick={() => handleApplyFilters()}>Apply</button>
                    </div>
                </div>
            </Dialog>

            <Dialog visible={showPopup} onHide={() => setShowPopup(false)} draggable={false} className="modal-large inspectra-grey-dialog" header="Procedural Errors Details">
                <div>
                    {popupData?.map((item, index) => (
                        <div key={index} className="inspectra-popup-card">
                            <div className="d-flex mb-1">
                                <div className="w30 fw-bold">Project Name:</div>
                                <div className="w70 text-wrap">{item?.project_name}</div>
                            </div>

                            <div className="d-flex mb-1">
                                <div className="w30 fw-bold">Procedure Name:</div>
                                <div className="w70 text-wrap">{item?.ProcedureName}</div>
                            </div>

                            {item?.sync_type && <div className="d-flex mb-1">
                                <div className="w30 fw-bold">Sync Type:</div>
                                <div className="w70 text-wrap">{item?.sync_type}</div>
                            </div>
                            }

                            <div className="d-flex mb-1">
                                <div className="w30 fw-bold">Error Line:</div>
                                <div className="w70 text-wrap">{item?.ErrorLine}</div>
                            </div>

                            <div className="d-flex mb-1">
                                <div className="w30 fw-bold">Error Message:</div>
                                <pre className="w70 text-wrap procedural-error-message">{item?.ErrorMessage}</pre>
                            </div>

                            <div className="d-flex mb-1">
                                <div className="w30 fw-bold">Log Date:</div>
                                <div className="w70 text-wrap">{new Date(item?.LogDate).toLocaleString()}</div>
                            </div>

                        </div>
                    ))}
                </div>
            </Dialog>

            <Dialog visible={expand} onHide={() => setExpand(false)} className="modal-xlarge" draggable={false} header="Procedural Error Expanded">
                <div>
                    <div className="text-primary inspectra-cursor inspectra-filter d-flex gap-1 align-items-center justify-content-end" onClick={() => setShowFilter(true)}>
                        <span className="inspectra-filter-count">{filterCount}</span>filters
                    </div>
                    <HighchartsReact className="highcharts-container" highcharts={Highcharts} options={options} containerProps={{
                        style: {
                            height: "99%"
                        }
                    }} />
                </div>
            </Dialog>

        </div>
    )
}

export default ProceduralError;